import React from 'react';
import { useDispatch } from 'react-redux';
// styles
import styles from './styles.module.scss';
// images
import FacebookPopupLogo from '@/public/images/facebookPopupLogo.svg';
import {
  BackArrow,
  GoogleIcon,
  LinkedinIcon,
} from '@/components/landing-page-templates/ConfigLandingPage/LandingPageIcons';
// types
import { IAccountRegistrationEnum } from '@/models/account/types';
import { ILoginType } from '@/components/landing-page-templates/ConfigLandingPage/types';
// components
import FacebookLoginButton from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/SocialLoginSection/FacebookLoginButton';
import LinkedInLoginButton from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/SocialLoginSection/LinkedInLoginButton';
import GoogleLoginButton from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/SocialLoginSection/GoogleLoginButton';
import SSOLoginButton from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/SocialLoginSection/SSOLoginButton';

const ExistingSocialLoginForm = ({
  email,
  updateLoginMethod,
  updateLastLoginMethod,
  lastLoginMethod,
  setNotificationMode,
  organizationId,
}) => {
  const dispatch = useDispatch();

  const handleBackButton = () => {
    updateLoginMethod(undefined);
    updateLastLoginMethod(undefined);
    // Set the registration step
    dispatch({
      type: 'account/setRegistrationStep',
      payload: { registrationStep: IAccountRegistrationEnum.LOGIN_METHOD },
    });
  };

  // The handler for a click on the back arrow
  const handleBackClick = () => {
    handleBackButton();
  };

  // The handler for the Enter key while focused on back arrow button
  const handleEnterKey = event => {
    if (event.key === 'Enter') {
      handleBackButton();
    }
  };

  let loginButton: any;
  let loginMethodText: string;
  switch (lastLoginMethod) {
    case ILoginType.FACEBOOK:
      loginButton = (
        <FacebookLoginButton
          updateLoginMethod={updateLoginMethod}
          updateLastLoginMethod={updateLastLoginMethod}
          existingLoginMethod={true}
          organizationId={organizationId}
        />
      );
      loginMethodText = 'Facebook';
      break;
    case ILoginType.LINKEDIN:
      loginButton = (
        <LinkedInLoginButton
          updateLoginMethod={updateLoginMethod}
          updateLastLoginMethod={updateLastLoginMethod}
          existingLoginMethod={true}
          organizationId={organizationId}
        />
      );
      loginMethodText = 'LinkedIn';
      break;
    case ILoginType.GOOGLE:
      loginButton = (
        <GoogleLoginButton
          updateLoginMethod={updateLoginMethod}
          updateLastLoginMethod={updateLastLoginMethod}
          existingLoginMethod={true}
          setNotificationMode={setNotificationMode}
          organizationId={organizationId}
        />
      );
      loginMethodText = 'Google';
      break;
    case ILoginType.SSO:
      loginButton = (
        <SSOLoginButton
          updateLoginMethod={updateLoginMethod}
          existingLoginMethod={true}
        />
      );
      loginMethodText = 'SSO';
      break;
    default:
      // Failed to match the lastLoginMethod to a login type; defaulting back to the login selection screen
      loginMethodText = 'another social method.';
      console.error(`Failed to match login method: ${lastLoginMethod}`);
      handleBackButton();
      break;
  }

  const emailText: string = email ? `"${email}"` : '';

  return (
    <div className={styles.container}>
      <div className={styles.sectionHeader}>
        {/* Back Arrow SVG */}
        <div
          role="button"
          tabIndex={0}
          className={styles.backArrow}
          onClick={handleBackClick}
          onKeyUp={handleEnterKey}
        >
          <BackArrow />
        </div>
        <div></div>
      </div>
      <div className={styles.loginSection}>
        {loginMethodText === 'Google' && <GoogleIcon size={74} />}
        {loginMethodText === 'LinkedIn' && <LinkedinIcon size={86} />}
        {loginMethodText === 'Facebook' && (
          <img
            src={FacebookPopupLogo}
            alt="Facebook"
            className={styles.facebookButtonIcon}
          />
        )}

        <p className={styles.sectionLabel}>Social Login</p>
        <p className={styles.sectionSubtext}>
          Your email <b>{emailText}</b> is already signed up
          <b> with {loginMethodText}.</b>
        </p>
        <div className={styles.loginButton}>{loginButton}</div>
      </div>
    </div>
  );
};
export default ExistingSocialLoginForm;
